import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 4.75A.75.75 0 0 1 3.75 4h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 3 4.75M19 5a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1m0 7a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1m0 7a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1M3.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }